import styled, { css } from 'styled-components';
import { media } from '@carvana/stc-styles';

import overlay from '../../../assets/images/wave.svg';
import { Halo } from '../../_shared/styles/layout';

const titleCopy = css`
  color: ${({ theme }) => theme.carvana.blue.dark};
  font-weight: 700;
  text-transform: uppercase;
`;

const gradient = css`
  background: radial-gradient(
    ellipse farthest-corner at top left,
    rgb(0, 63, 158) 0%,
    rgb(0, 178, 217) 60%,
    rgb(112, 234, 242) 100%
  );
`;

const HeaderBg = styled.div`
  margin-bottom: 24px;
  padding-bottom: 122px;
  padding-top: 50px;

  &.decorated {
    background: url(${overlay});
  }

  &.error {
    height: 196px;
  }

  ${media.sm`
    padding-bottom: 167px;
    padding-top: 51px;

    &.error {
      height: 150px;
    }
  `}

  ${media.md`
    padding-bottom: 158px;
    padding-top: 50px;

    &.error {
      height: 185px;
    }
  `}
`;

const Heading = styled.h1`
  ${titleCopy}
  color: ${({ theme }) => theme.carvana.white.primary};
  font-size: 42px;
  line-height: 42px;

  ${media.sm`
    font-size: 42px;
    line-height: 42px;
    &.error {
      width: 500px;
    }
  `}

  ${media.md`
    font-size: 64px;
    line-height: 60px;
    margin-left: -4px;
    &.error {
      width: 600px;
    }
  `}
`;

const HeaderContent = styled.div`
  max-width: 327px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 3px;

  &.forceHeaderLineBreak {
    max-width: 303px;
    padding-right: 24px;
  }

  ${media.sm`
    &.forceHeaderLineBreak {
      max-width: 704px;
      padding-right: 0;
    }
    max-width: 704px;
    padding-right: 0;
    margin-top: -1px;
  `}

  ${media.md`
    &.forceHeaderLineBreak {
      max-width: 960px;
    }
    max-width: 960px;
    margin-top: 0;
  `}
`;

const Subheading = styled.p`
  color: ${({ theme }) => theme.carvana.white.primary};
  font-size: 18px;
  line-height: 26px;
  margin-top: 8px;
  max-width: 312px;

  &.forceSubheaderLineBreak {
    max-width: 212px;
  }

  ${media.sm`
    &.forceSubheaderLineBreak {
      max-width: unset;
    }
    max-width: 366px;
    font-size: 18px;
    line-height: 26px;
  `}

  ${media.md`
    font-size: 24px;
    line-height: 30px;
    margin-left: -4px;
    margin-top: 24px;
    max-width: 710px;
  `}

  &.lowValue {
    max-width: 305px;

    ${media.sm`
      max-width: 450px;
    `}

    ${media.md`
      max-width: 555px;
    `}
  }
`;

const StyledHalo = styled(Halo)`
  margin-top: 0;
  margin-bottom: 14px;
  width: 30px;

  ${media.md`
    margin-bottom: 13px;
  `}
`;

const Wrapper = styled.section`
  ${gradient}
`;

export { HeaderBg, HeaderContent, Heading, StyledHalo, Subheading, Wrapper };
